var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-switch',{staticClass:"ml-20",attrs:{"active-text":"investment","active-value":"investment","inactive-text":"case","inactive-value":"case"},model:{value:(_vm.operatingMode),callback:function ($$v) {_vm.operatingMode=$$v},expression:"operatingMode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }